@if(currentView === views.Home) {
  <div class="container">
    <button (click)="selectView(views.ConnectionStrings)" class="request-button">Ver Cadenas de conexión</button>

    <button (click)="selectView(views.CreatingConnectionString)" class="request-button">Crear Cadenas de conexión</button>
  </div>

  <!-- <div class="connectionStrings-searched-container">
    <div class="connectionString-search-information">
      <p class="text-info">Devuelve la información de una Cadena de conexión (GET).</p>
      <button (click)="getConnectionString()">Buscar Cadena de conexión</button>
      <div class="name-input-container">
        <input type="text" [(ngModel)]="connectionStringNameToSearch" class="name-input" placeholder="Nombre">
        @if(connectionStringNotFound) {
          <p class="connectionString-not-found">Cadena de conexión no encontrada</p>
        }
      </div>
    </div>

    <div class="connectionString-searched">
      <p><strong>Nombre: </strong>{!!connectionStringSearched ? connectionStringSearched.nombre : ''}}</p>
      <p><strong>Valor: </strong>{{!!connectionStringSearched ? connectionStringSearched.valor : ''}}</p>
    </div>
  </div> -->
}

@if(currentView === views.ConnectionStrings) {
  <div class="search-container">
    <input type="text" class="search-input" [(ngModel)]="connectionStringToSearch" (ngModelChange)="onSearchChange()" placeholder="Buscar por nombre">
    <button class="back-button button button-colors" (click)="selectView(views.Home)">Volver</button>
  </div>

  <!-- Vista de ConnectionStrings -->
  <div class="scroll-container">
    @for(connectionString of connectionStrings; track connectionString.nombre) {
      <div class="connectionString">
        <p class="connectionString-data"><strong>Nombre: </strong>{{connectionString.nombre}}</p>

        <p class="connectionString-data"><strong>Valor: </strong>{{connectionString.valor}}</p>

        <div class="connectionStrings-buttons">
          <button class="delete-button" (click)="deleteConnectionString(connectionString)">
            <img src="assets/icons/delete.svg">
            <span>Eliminar</span>
          </button>

          <button class="modify-button" (click)="selectView(views.EditingConnectionString, connectionString)">
            <img src="assets/icons/edit.svg">
            <span>Modificar</span>
          </button>
        </div>
      </div>
    }
  </div>
}

<!-- Vista de crear y editar ConnectionString -->
@if(currentView === views.CreatingConnectionString || currentView === views.EditingConnectionString) {
  <div class="create-connectionString-container">
    <h4>{{currentView === views.CreatingConnectionString ? 'Crear Cadena de Conexión' : 'Editando Cadena de Conexión con nombre "' + (!!connectionStringSelected ? connectionStringSelected.nombre : '') + '"'}}</h4>

    <input type="text" class="new-input" [(ngModel)]="name" placeholder="Nombre">

    <textarea type="text" class="textarea" [(ngModel)]="value" placeholder="Valor"></textarea>

    <div class="create-buttons">
      <button class="button button-colors"
        (click)="currentView === views.CreatingConnectionString ? selectView(views.Home) : selectView(views.ConnectionStrings)">
        Volver
      </button>

      <button class="button button-colors" (click)="currentView === views.CreatingConnectionString ? createConnectionString() : editConnectionString()"
        [disabled]="!globalService.editing || !name || name.length === 0 || name === ' '">Confirmar</button>
    </div>
  </div>
}